import { FC, useEffect, useState } from 'react'
import './ScreenShareChoosePopup.scss';
import { Checkbox, Dialog, ThemeProvider } from '@mui/material';
import { theme } from '../../../utils/constants';
import images from '../../../assets/images';
import ScreenCard from './ScreenCard';
import { useGlobalState } from '../../../MeetContext/MeetContext';
import { useContentShareControls } from 'amazon-chime-sdk-component-library-react';


export interface ScreenSource {
    name: string;
    id: string;
    appIconDataURI: string,
    thumbnailDataURI: string
}

const ScreenShareChoosePopup:FC = () => {

    const {PopupCloseIcon} = images;
    const [selectedScreen, setSelectedScreen] = useState<string>();
    const { openShareScreenPopup, setOpenShareScreenPopup,  } = useGlobalState();
    const [screenDetails, setScreenDetails] = useState<ScreenSource[]>([]);
    const [shareAudio, setShareAudio] = useState<boolean>(false);
    const { toggleContentShare } = useContentShareControls();
   
    useEffect(() => {
        const fetchScreenSources = async () => {
          try {
            const sources = await window.electron.getScreenSources();
            console.log("getScreenSources", window.electron.getScreenSources());
            setShareAudio(false);
            setSelectedScreen(undefined);
            setScreenDetails(sources as unknown as any);
          } catch (error) {
            console.error('Error fetching screen sources:', error);
          }
        };

        if (window.electron && window.electron.isElectron()) {
            fetchScreenSources();
        }
    
      }, [openShareScreenPopup]);

      const handleClick = async () => {
        if (selectedScreen) {
            console.log("getScreenSource", window.electron.setScreen(selectedScreen));
            window.electron.setScreen(selectedScreen);
            // startScreenShare();
            const mediaStream = await navigator.mediaDevices.getDisplayMedia({
                video: true,
                audio: shareAudio,
              });
            await toggleContentShare(mediaStream);
            setOpenShareScreenPopup(false);
        }
    }

    const handleClose = () => {
        setShareAudio(false);
        setOpenShareScreenPopup(false);
        setSelectedScreen(undefined);
    }

    const handleChangeChecked = () => {
        setShareAudio(!shareAudio);
    }

    console.log("share audio is outside", shareAudio);
    
  return (
    <>
         <ThemeProvider theme={theme}>
            <Dialog 
                open={openShareScreenPopup} 
                onClose={() => setOpenShareScreenPopup(false)}
                classes={{ 
                    paper: 'screenSharePopupPaper', 
                }}
                PaperProps={{
                    style: {
                        width: '1018px',
                        height: '440px',
                        maxWidth: 'none',
                        maxHeight: 'none'
                    }
                }}
            >
                <div className={`screenSharePopupContainer`}>
                    <div className='screenListContainer'>
                        <div className='headerContainer'>
                            <div className='headerTextStyle'>{`Select which screen you want to share`}</div>
                            <img src={PopupCloseIcon} alt='close' className='closeIconStyle' onClick={handleClose}/>
                        </div>
                        <div className='screensContainer'>
                            {
                                screenDetails?.map((item: ScreenSource, index: number) => {
                                    return (
                                        <ScreenCard key={item.id} data={item} index={index} selectedScreen={selectedScreen} setSelectedScreen={setSelectedScreen}/>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className='buttonContainer'>
                        <div className='checkboxContainer'>
                            <Checkbox
                                checked= {shareAudio}
                                onChange={handleChangeChecked}
                            />
                            Share Audio
                        </div>
                        <button className='btnStyle' onClick={handleClick}>Share</button>
                    </div>
                </div>
            </Dialog>
        </ThemeProvider>
    </>
  )
}

export default ScreenShareChoosePopup
